import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface Alert {
  id: string;
  alertType: string;
  isOpen: boolean;
  message: string;
}

export interface AlertState {
  alerts: Alert[];
}

const initialState: AlertState = {
  alerts: [],
};

const alertSlice = createSlice({
  name: "alerts",
  initialState,
  reducers: {
    setAlert: (state, action: PayloadAction<Alert>) => {
      state.alerts.push(action.payload);
    },
    removeAlert: (state, action: PayloadAction<string>) => {
      state.alerts = state.alerts.filter(
        (alert) => alert.id !== action.payload
      );
    },
    toggleAlert: (state, action: PayloadAction<number>) => {
      const index = action.payload;
      if (state.alerts[index]) {
        state.alerts[index].isOpen = !state.alerts[index].isOpen;
      }
    },
  },
});

export const { setAlert, removeAlert, toggleAlert } = alertSlice.actions;

export default alertSlice.reducer;
